const IconMinus = (): JSX.Element => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 13.5H13H11H5L5 11.5H11H13H19L19 13.5Z"
        fill="currentColor"
      />
    </>
  );
};

export default IconMinus;
